<template>
    <div v-if="unitObject" class="unit" :class="getClasses" :style="{backgroundImage: `url(${getImage})`}" @mouseenter="mouseOn = true" @mouseleave="mouseOn = false">
        <unit-info-panel v-if="mouseOn && !selectMode() " :unitObject="unitObject"> </unit-info-panel>
    </div>
</template>

<script>
import UnitInfoPanel from './UnitInfoPanel.vue';
export default {
    components: { UnitInfoPanel },
    inject: {
        selectMode: {
            type: Boolean
        }
    },
    data() {
        return {
            mouseOn: false,
        };
    },
    props: {
        unitObject: {
            type: Object,
            required: true
        },
        needsMargin: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        getImage(){
            let images = require.context('/public/images/units/', false, /\.png$/);
            return images(`./${this.unitObject.id}.png`);
        },
        getClasses(){
            let classes = [`unit-team-${this.unitObject.team}`];
            if(this.needsMargin){
                classes.push('unit-pointer');
            }
            return classes;
        }
    }
}
</script>

<style scoped>
.unit{
    margin: 3%;
    width: 35.75px;
    height: 35.75px;
    background-size: cover;
    user-select: none;
    border-radius: 3px;
}
.unit-team-blue{
    box-shadow: inset 0px 0px 2px 2px var(--team-blue);
}
.unit-team-red{
    box-shadow: inset 0px 0px 2px 2px var(--team-red);
}
.unit-pointer{
    position: relative !important;
}
</style>